import { useTranslation } from "react-i18next";

const NormalBankPayment = ({
  paymentList,
  morePaymentList,
  setBankPaymentSelected,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`deposit.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  return (
    <section>
      <span className="text-transaction-text dark:text-base-light-white">
        {i18n("selectChannel")}
      </span>
      <select
        onChange={(e) => {
          const selectedBankCode = e.target.value;
          const flatList = Object.values(morePaymentList).flat();
          const selectedItem = flatList.find(
            (item) => item.bankcode === selectedBankCode
          );
          setBankPaymentSelected(selectedItem);
        }}
        className="w-full bg-transaction-card dark:bg-base-light-dark dark:text-base-light-white rounded-[5px] py-[10px] px-[12px] outline-0 text-transaction-text"
      >
        <option value="" disabled selected>
          {i18n_common("pleaseSelect")}
        </option>
        {paymentList.map((list) => {
          const item = morePaymentList[list];
          return <option value={item.bankcode}>{item.bankcode}</option>;
        })}
      </select>
    </section>
  );
};

export default NormalBankPayment;
